module.exports = __webpack_public_path__ + "img/huffingtonpost.516cace3.svg";